(() => {
  const root = document.querySelector('[data-model-product]');
  if (!root) return;
  // A displayed bundle offer must add both qualifying products, not the accessory alone.
  root.addEventListener('submit', async event => {
    const form = event.target;
    const offer = form.querySelector('[name="gastro_bundle_main"]');
    if (!offer) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.adding) return;
    const mainVariant = root.querySelector('#GastroModelProductForm [name="id"]');
    const mainData = root.querySelector('[data-model-variant="' + mainVariant.value + '"]');
    const fi = document.documentElement.lang.startsWith('fi');
    const text = (en, finnish) => fi ? finnish : en;
    let status = form.parentElement.querySelector('[data-cart-status]');
    if (!status) { status = document.createElement('p'); status.dataset.cartStatus = ''; status.setAttribute('role', 'status'); form.after(status); }
    if (!mainData || mainData.dataset.available !== 'true') { status.textContent = text('Select an available main product to buy this bundle.', 'Valitse saatavilla oleva päätuote ostaaksesi paketin.'); return; }
    const button = form.querySelector('[type="submit"]'), label = button.textContent;
    form.dataset.adding = 'true'; button.disabled = true; button.textContent = text('Adding…', 'Lisätään…'); status.textContent = '';
    try {
      const mainId = Number(mainVariant.value), companionId = Number(form.querySelector('[name="id"]').value);
      if (mainId === companionId) throw new Error(text('Choose two different products.', 'Valitse kaksi eri tuotetta.'));
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: mainId, quantity: 1 }, { id: companionId, quantity: 1 }] }) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || text('Unable to add this bundle.', 'Pakettia ei voitu lisätä.'));
      status.textContent = text('Both products added. ', 'Molemmat tuotteet lisätty. ');
      const link = document.createElement('a'); link.href = (window.Shopify?.routes?.root || '/') + 'cart'; link.textContent = text('View cart', 'Näytä ostoskori'); status.append(link);
      window.dispatchEvent(new Event('gastro:cart-updated'));
      window.gastroCartConfirmation?.(result, button);
    } catch (error) { status.textContent = error.message; }
    finally { delete form.dataset.adding; button.disabled = false; button.textContent = label; }
  }, true);
  const bundle = root?.querySelector('[data-product-bundle]');
  if (!bundle) return;
  const fi = document.documentElement.lang.startsWith('fi');
  const t = (en, finnish) => fi ? finnish : en;
  const variant = root.querySelector('#GastroModelProductForm [name=id]');
  const button = bundle.querySelector('[data-buy-bundle]');
  const status = bundle.querySelector('[data-bundle-status]');
  const selected = () => [...bundle.querySelectorAll('[data-accessory]:checked:not(:disabled)')];
  const current = () => root.querySelector('[data-model-variant="' + variant.value + '"]');
  const update = () => {
    const data = current();
    const total = Number(data.dataset.price) + selected().reduce((sum, item) => sum + Number(item.dataset.price), 0);
    bundle.querySelector('[data-bundle-total]').textContent = new Intl.NumberFormat(fi ? 'fi-FI' : (document.documentElement.lang.startsWith('lt') ? 'lt-LT' : 'en-IE'), {style: 'currency', currency: bundle.dataset.currency || 'EUR'}).format(total / 100);
    button.disabled = data.dataset.available !== 'true';
  };
  bundle.addEventListener('change', update);
  variant.addEventListener('change', update);
  update();
  button.addEventListener('click', async () => {
    if (button.disabled) return;
    button.disabled = true;
    const label = button.textContent;
    button.textContent = t(window.gastroTranslate('Adding…'), 'Lisätään…');
    status.textContent = '';
    try {
      const items = [{id: Number(variant.value), quantity: 1}, ...selected().map(item => ({id: Number(item.dataset.variant), quantity: 1}))];
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({items})});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || t(window.gastroTranslate('Unable to add this set.'), 'Settiä ei voitu lisätä.'));
      status.textContent = t(window.gastroTranslate('Set added to cart.'), 'Setti lisätty ostoskoriin.');
      window.dispatchEvent(new Event('gastro:cart-updated'));
      window.gastroCartConfirmation?.(result, button);
    } catch (error) {
      status.textContent = error.message;
    } finally {
      button.textContent = label;
      update();
    }
  });
})();

